export const alerts4countries = {
  US: {
    active: false,
    title: 'AlertForCountry.Title.US',
    message: 'AlertForCountry.Description.US',
    storeLocatorButton: true,
  },
}

export default alerts4countries
export type Alerts4Countries = typeof alerts4countries
